import { memoizeObject } from "@utils/memoize";

const woosmapServices: {
    LocalitiesService?: woosmap.map.LocalitiesService;
    StoresService?: woosmap.map.StoresService;
    DistanceService?: woosmap.map.DistanceService;
} = {};

export const useWoosmapServices = () => {
    woosmapServices.LocalitiesService ||= memoizeObject(
        new woosmap.map.LocalitiesService(),
    );
    woosmapServices.StoresService ||= memoizeObject(
        new woosmap.map.StoresService(),
    );
    woosmapServices.DistanceService ||= memoizeObject(
        new woosmap.map.DistanceService(),
    );

    return {
        LocalitiesService: woosmapServices.LocalitiesService,
        StoresService: woosmapServices.StoresService,
        DistanceService: woosmapServices.DistanceService,
    };
};
